"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestProgressSnapshotUserToJSON = exports.QuestProgressSnapshotUserFromJSONTyped = exports.QuestProgressSnapshotUserFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function QuestProgressSnapshotUserFromJSON(json) {
    return QuestProgressSnapshotUserFromJSONTyped(json, false);
}
exports.QuestProgressSnapshotUserFromJSON = QuestProgressSnapshotUserFromJSON;
function QuestProgressSnapshotUserFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userId': json['userId'],
        'isComplete': !(0, runtime_1.exists)(json, 'isComplete') ? undefined : json['isComplete'],
        'claimedAt': !(0, runtime_1.exists)(json, 'claimedAt') ? undefined : json['claimedAt'],
        'pointsReset': json['pointsReset'],
        'pointsTotal': json['pointsTotal'],
        'progression': ((0, runtime_1.mapValues)(json['progression'], _1.QuestProgressionMilestoneFromJSON)),
    };
}
exports.QuestProgressSnapshotUserFromJSONTyped = QuestProgressSnapshotUserFromJSONTyped;
function QuestProgressSnapshotUserToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userId': value.userId,
        'isComplete': value.isComplete,
        'claimedAt': value.claimedAt,
        'pointsReset': value.pointsReset,
        'pointsTotal': value.pointsTotal,
        'progression': ((0, runtime_1.mapValues)(value.progression, _1.QuestProgressionMilestoneToJSON)),
    };
}
exports.QuestProgressSnapshotUserToJSON = QuestProgressSnapshotUserToJSON;
